import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class JobAnalysis {

    name: string;
    description: string;
    doStator: boolean;
    doRotor: boolean;

    constructor() { }
}

export class RotorType {

    name: string;
    description: string;

    constructor() { }
}

export class StatorType {

    name: string;
    description: string;

    constructor() { }
}